import { Controller } from "stimulus";
import { throttle } from "../../util";

export default class extends Controller {
  static targets = ["content", "tableOfContents", "tableOfContentsItems", "showSidebarMenuButton", "showMenuButton", "hideMenuButton", "postContent", "postHeading"]

  connect() {
    // Skip registration if there are no table of contents for the article.
    if (!this.hasTableOfContentsTarget)
      return;

    // Inject smooth scrolling style for html element.
    document.querySelector("html").style.scrollBehavior = "smooth";

    this.dropdownMenuOpened = false;
    this.sidebarMenuOpened = true;
    this.contentHeaders = Array.from(this.contentTarget.getElementsByTagName("h2"));

    // Sidebar menu is hidden by default in case there's no ToC for article.
    this._showSidebarMenu();
    this._highlightElementOnTableOfContents();
    this._toggleMobileTableOfContentsVisibility();

    window.addEventListener("scroll", throttle(this._highlightElementOnTableOfContents.bind(this), 50));
    window.addEventListener("scroll", throttle(this._toggleMobileTableOfContentsVisibility.bind(this), 100));
  }

  toggleMenu() {
    if (window.innerWidth >= 1024)
      this._toggleSidebarMenu();
    else
      this._toggleDropdownMenu();
  }

  // =============================================
  // Sidebar menu functions (desktop)
  // =============================================
  _toggleSidebarMenu() {
    if (this.sidebarMenuOpened)
      this._hideSidebarMenu();
    else
      this._showSidebarMenu();
  }

  _showSidebarMenu() {
    this.sidebarMenuOpened = true;
    this.tableOfContentsTarget.classList.add("lg:tw-block");
    this.tableOfContentsTarget.classList.remove("lg:tw-hidden");
    this.contentTarget.classList.remove("lg:tw-col-start-2");
    this.contentTarget.classList.add("lg:tw-pr-12", "lg:tw-border-r");

    this.showSidebarMenuButtonTarget.classList.add("lg:tw-hidden");
    this.showSidebarMenuButtonTarget.classList.remove("lg:tw-flex");
  }

  _hideSidebarMenu() {
    this.sidebarMenuOpened = false;
    this.tableOfContentsTarget.classList.remove("lg:tw-block");
    this.tableOfContentsTarget.classList.add("lg:tw-hidden");
    this.contentTarget.classList.add("lg:tw-col-start-2");
    this.contentTarget.classList.remove("lg:tw-pr-12", "lg:tw-border-r");

    this.showSidebarMenuButtonTarget.classList.remove("lg:tw-hidden");
    this.showSidebarMenuButtonTarget.classList.add("lg:tw-flex");
  }


  // =============================================
  // Dropdown menu functions (mobile)
  // =============================================
  _toggleDropdownMenu() {
    if (this.dropdownMenuOpened)
      this._hideDropdownMenu();
    else
      this._showDropdownMenu();
  }

  _showDropdownMenu() {
    this.dropdownMenuOpened = true;
    this.tableOfContentsItemsTarget.classList.remove("tw-hidden");
    this.hideMenuButtonTarget.classList.remove("tw-hidden");
    this.showMenuButtonTarget.classList.add("tw-hidden");
  }

  _hideDropdownMenu() {
    this.dropdownMenuOpened = false;
    this.tableOfContentsItemsTarget.classList.add("tw-hidden");
    this.showMenuButtonTarget.classList.remove("tw-hidden");
    this.hideMenuButtonTarget.classList.add("tw-hidden");
  }


  // =============================================
  // Scroll handler functions
  // =============================================
  _toggleMobileTableOfContentsVisibility() {
    if (this.postContentTarget.getBoundingClientRect().top > 50) {
      this.tableOfContentsTarget.classList.add("tw-hidden");
    } else {
      this.tableOfContentsTarget.classList.remove("tw-hidden");
    }
  }

  _highlightElementOnTableOfContents() {
    let previousElement = this.tableOfContentsItemsTarget.querySelector(".active-section");
    if (previousElement) {
      previousElement.classList.remove("active-section")
    }

    let nearestElement = this.contentHeaders.filter(x => x.getBoundingClientRect().top <= 175).reverse()[0];
    if (nearestElement) {
      let tableOfContentsItem = this.tableOfContentsItemsTarget.querySelector(`a[href="#${nearestElement.id}"]`);
      tableOfContentsItem?.classList?.add("active-section");
    }
  }
}
